import React from 'react';
import { EmptyStatePresets } from 'new/modules/ai/components/EmptyState';
import { EXPRESS_URL } from 'new/constants/pathnames';

export function EmptyMCPFlowsState() {
  return (
    <EmptyStatePresets.NoMCPFlows
      onOpenStudio={() => window.open(EXPRESS_URL, '_blank', 'noopener,noreferrer')}
    />
  );
}
